import PropTypes from "prop-types";
import { useRef } from "react";
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { Stack, TextField } from "@mui/material";
// hooks
import useEventListener from "../../hooks/useEventListener";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

RHFCodes.propTypes = {
  keyName: PropTypes.string,
  inputs: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
};

export default function RHFCodes({ keyName = "", inputs = [], type = "number", ...other }) {
  const codesRef = useRef(null);

  const { control, setValue } = useFormContext();
  const isMobile = useResponsive("down", "sm");

  const handlePaste = (event) => {
    let data = event.clipboardData.getData("text");

    data = data.split("");

    inputs.map((input, index) => setValue(input, data[index]));

    event.preventDefault();
  };

const handleChangeWithNavigation = (event, handleChange) => {
  const { maxLength, value, name } = event.target;

  const fieldIndex = Number(name.replace(keyName, ""));
  const nextField = document.querySelector(
    `input[name=${keyName}${fieldIndex + 1}]`
  );
  const prevField = document.querySelector(
    `input[name=${keyName}${fieldIndex - 1}]`
  );

  let newValue = value;

  if (type === "string") {
    newValue = newValue.toUpperCase();
  }

  if (newValue.length > maxLength) {
    newValue = newValue[0];
  }

  // Update RHF first
  handleChange(newValue);

  // EMPTY → move backward
  if (newValue === "" && prevField) {
    prevField.focus();
    return;
  }

  // FILLED → move forward
  if (newValue.length === maxLength && nextField) {
    nextField.focus();
  }
};

const handleKeyDown = (event) => {
  if (event.key !== "Backspace") return;

  const { name, value } = event.target;
  const fieldIndex = Number(name.replace(keyName, ""));

  // If current field is empty → jump back
  if (value === "" && fieldIndex > 1) {
    const prevName = `${keyName}${fieldIndex - 1}`;
    const prevField = document.querySelector(`input[name=${prevName}]`);

    if (prevField) {
      event.preventDefault(); // stop browser doing nothing
      setValue(prevName, ""); // clear previous
      prevField.focus();
    }
  }
};


  useEventListener("paste", handlePaste, codesRef);

  return (
    <Stack direction="row" spacing={isMobile ? 1 : 2} justifyContent="center" ref={codesRef}>
      {inputs.map((name, index) => (
        <Controller
          key={name}
          name={`${keyName}${index + 1}`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              error={!!error}
              autoFocus={index === 0}
              placeholder="-"
              onChange={(event) => {
                handleChangeWithNavigation(event, field.onChange)
              }}
              onKeyDown={handleKeyDown}
              onFocus={(event) => event.currentTarget.select()}
              InputProps={{
                sx: {
                  flex: 1,
                  "& input": { p: 0, textAlign: "center", height: 56, maxWidth: 56 },
                },
              }}
              inputProps={{
                maxLength: 1,
                type: type,
              }}
              {...other}
            />
          )}
        />
      ))}
    </Stack>
  );
}
